import ClientFlow from "./pages/client/ClientFlow";
import LoginPage from "./pages/admin/LoginPage";
import BootstrapOwnerPage from "./pages/admin/BootstrapOwnerPage";
import OwnerDashboard from "./pages/admin/owner/OwnerDashboard";
import OperatorDashboard from "./pages/admin/operator/OperatorDashboard";
import { AuthProvider, useAuth } from "./context/AuthContext";

/**
 * Намеренно без react-router: у проекта всего 4 маршрута админки + один клиентский флоу
 * (который сам управляет своими "экранами" через локальное состояние, не через URL —
 * см. ClientFlow.tsx). Добавлять зависимость ради четырёх статических путей — лишний вес
 * и лишняя точка отказа при офлайн-сборке. Если роутов станет больше — imeet смысл
 * подключить react-router-dom, простая замена.
 */
export default function App() {
  const path = window.location.pathname;

  if (path.startsWith("/admin")) {
    return (
      <AuthProvider>
        <AdminRouter path={path} />
      </AuthProvider>
    );
  }

  return <ClientFlow />;
}

function AdminRouter({ path }: { path: string }) {
  const { user, loading } = useAuth();

  if (path === "/admin/setup") return <BootstrapOwnerPage />;

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center bg-gm-bg text-gm-muted">Загрузка…</div>;
  }
  if (!user) return <LoginPage />;
  return user.role === "owner" ? <OwnerDashboard /> : <OperatorDashboard />;
}
